{
  "_ARTVIKT": "Paino",
  "SEE_ALL_DOWNLOADS": "Näytä kaikki lataukset",
  "PRODUCT_SPECIFICATION": "Tuotespesifikaatio",
  "OH_TA_MAILNOTIFIED": "Sähköposti, tilausvahvistus",
  "OH_Q_OH_TELEAVISERING": "Vastaanottajan puhelinnumero",
  "OH_EDITEXT": "Viesti",
  "TYLO_FREIGHT_COST": "Kuljetuskustannukset, jotka ovat <strong> {{value}} {{currencyCode}} </strong>, lisätään.",
  "TYLO_FREIGHT_COST_ERROR": "Rahtikustannuksia ei voitu arvioida",
  "TYLO_MIN_ORDER_ADMIN_FEE": "Järjestelmänvalvojan maksu {{fee}} otetaan käyttöön (min. Tilaus {{min}})",
  "ADMIN_CHARGE": "Järjestelmänvalvojan maksu",
  "PART_DELIVERY": "Osittaiset toimitukset",
  "TYLO_PART_DELIVERY_MESSAGE": "Tuotteet toimitetaan osittain, rahti veloitetaan jokaisesta toimituksesta.",
  "TYLO_OH_LEVSATTKOD_1": "DSV",
  "TYLO_OH_LEVSATTKOD_5": "DSV, ilmoitus",
  "TYLO_OH_LEVSATTKOD_66": "DHL, palvelupiste",
  "TYLO_OH_LEVSATTKOD_67": "DHL, B2B",
  "TYLO_OH_DELLEVTILLATEN_0": "Kyllä",
  "TYLO_OH_DELLEVTILLATEN_10": "Ei",
  "TYLO_TRACK_ORDER": "Seuraa ja jäljitä",
  "ADD_TO_CART": "Tilaa",
  "CATEGORY_LEVEL_3": "Alaluokka",
  "DELIVERY_PLANNING": "Toimituksen suunnittelu",
  "TYLO_EDIT_DELIVERY_ADDRESS": "Vaihda toimitusosoite",
  "TYLO_DELIVERY_TIME_PRELIMINARY": "Toimitusaika on alustava, toimituspäivä päätetään, kun tuotanto on suunniteltu.",
  "CLAIM_FORM": "Reklamaatiolomake",
  "EDIT_NOTE": "Muokkaa muistiinpanoa",
  "HIDE_PRICE": "Piilota hinta",
  "REQUEST_DELIVERY_DATE": "Pyydetty toimituspäivä",
  "RESTORE_AVAILABLE_DATES": "Palauta käytettävissä olevat päivämäärät",
  "Q_MS_AR_COLOR": "Väri",
  "Q_MS_AR_KW": "Teho",
  "Q_MS_AR_RSIZE": "Kivimäärä",
  "Q_MS_AR_SSIZE": "Saunan koko",
  "ARTVIKT": "Nettopaino",
  "ARTBTOTVIKT": "Bruttopaino",
  "Q_MS_ARTLENGTH": "Tuotteen leveys",
  "Q_MS_ARTHEIGHT": "Tuotteen korkeus",
  "Q_MS_ARTWIDTH": "Tuotteen syvyys",
  "Q_AR_LANGD": "Pakkauksen leveys",
  "Q_AR_HOJD": "Pakkauksen korkeus",
  "Q_AR_BREDD": "Pakkauksen syvyys",
  "Q_MS_AR_SD1": "Suojaetäisyys eteen",
  "Q_MS_AR_SD2": "Suojaetäisyys taakse",
  "Q_MS_AR_SD3": "Suojaetäisyys ylös",
  "Q_MS_AR_SD4": "Suojaetäisyys sivulle",
  "Q_MS_AR_SD5": "Suojaetäisyys vesisäiliön",
  "Q_MS_AR_SD6": "Suojaetäisyys alas",
  "Q_MS_AR_VOLT1": "Jännite 1",
  "Q_MS_AR_VOLT2": "Jännite 2",
  "Q_MS_AR_VOLT3": "Jännite 3",
  "Q_MS_AR_VOLT4": "Jännite 4",
  "ARTSTATNR": "Tullikoodi",
  "Q_AR_SSTL": "Sähkönumero",
  "ARTNREAN": "EAN tuotenumero",
  "URSPRUNGSLAND": "Alkuperämaa",
  "TARIC_CODE": "Tullinumero",
  "CART_ARTICLE_SKU_TOTAL": "{{article}} artikkelia",
  "NO_AVAILABILITY": "Ei varastossa",
  "EXPECTED_DATE": "Saatavilla {{date}}",
  "PRODUCT_EXPORT_NAV_BAR": "Vie tuotetiedot",
  "NEWS": "Uutiset",
  "OUT_OF_STOCK": "Ei varastossa",
  "OH_ORDLEVADR1": "Vastaanottaja",
  "DIGITAL_ASSETS": "Kuvapankki",
  "OH_ORDLEVADR2": "Vastaanottajan puhelinnumero",
  "FTGPOSTADR3": "Kaupunki",
  "BASE": "Kategoria",
  "CUSTOM": "Kategoria",
  "ARCTINAR": "Kategoria",
  "TYLOINC": "Kategoria",
  "BASESÄHKÖLIIKE": "Kategoria",
  "CREDIT_BLOCKED": "Tilauksen tekeminen ei onnistu, ota yhteyttä asiakaspalveluun",
  "AMOUNT_OF_CREDIT_LEFT": "Amount of credit left {{creditLeft}}",
  "VISIBLE_ON_DOCUMENT_PAGE": "Näkyy asiakirjasivulla",
  "HELO_ORDLEVADR_EXTRA": "Toimitusosoite 2 (valinnainen)",
  "HELO_ORDLEVADR_EXTRA2": "Toimitusosoite 3 (valinnainen)",
  "COMPANY": "Yritys",
  "FREE_FORM_DESCRIPTION": "Reklamaation kuvaus",
  "EMAIL": "Sähköpostiosoite",
  "POSTAL_CODE_CITY": "Postinumero",
  "CUSTOMER_NUMBER": "Asiakasnumero",
  "STREET_ADDRESS": "Katuosoite",
  "YELLOW_LINE": "Syy",
  "CLAIM_INFORMATION": "Täytä reklamaatiotiedot mahdollisimman tarkasti, jotta asia voidaan käsitellä viipymättä. Käsittelemme reklamaatioita vain kirjallisesti.",
  "TYPE": "Reklamaation aihe",
  "CUSTOMER_ORDER_ID": "Kundbestnr",
  "CONCEPT_SHOW_DETAILS": "Selaa tuotteita",
  "MORE_EXPECTED_DATE": "Lisää odotetaan {{date}}",
  "TYLO_ARRANGES_FREIGH": "Tylö järjestää rahdin*",
  "TYLO_ARRANGES_FREIGH_TERM": "*Vähimmäistilausarvo 500€. Jos tilausarvo on alempi, lisätään hallintomaksu 30€",
  "TYLO_ARRANGES_FREIGH_NOTE": "Jotta vältytään useilta rahtimaksuilta, varmista, että kaikilla riveillä on samat toimituspäivät. Kun lähetys on varattu rahdinkuljettajalta, hinta on saatavilla kohdassa Aiemmat tilaukset",
  "TYLO_CART_NOTE_29_37": "The delivery date is preliminary and will manually be changed to first available delivery date (based on the lead time for each article) once your account balance is met.\n\nStandard orders cannot be postponed or cancelled later than 5 working days prior confirmed dispatch date.",
  "DAMAGED_IN_TRANSPORT": "Kuljetusvaurio",
  "AMOUNT_OF_PRODUCTS": "Tuotteiden lukumäärä",
  "WRONG_PRODUCT": "Väärä tuote",
  "INVOICING": "Laskutus",
  "TECHNICAL_FAULT": "Tekninen vika",
  "TYLO_FREIGHT_COST_MANUAL": "Toimitushintaa ei ole laskettu, vaan se lasketaan manuaalisesti. Tilausvahvistus, joka sisältää toimitushinnan, lähetetään erikseen.",
  "AVAILABLE_NUMBER_EXCEEDED_ALERT": "Tätä tuotetta ei voi tilata suurempaa määrää. Ota yhteyttä tukeemme osoitteessa <a href='mailto:tps@sauna360.com'>tps@sauna360.com</a>, niin he auttavat sinua.",
  "PARTIAL_DELIVERY_POPUP_TEXT": "Osittaisesta toimituksesta veloitetaan toimitus jokaisella toimituskerralla",
  "ESTIMATED_PRODUCTION_TIME": "Arvioitu tuotantoaika {{leadtime}} päivää tilauksesta"
}
